import { useEffect } from "react";
import LBox from "@components/LBox";
import { LBoxProps } from "@components/LBox";
import type { QueueItem } from "@utils/player/utils/queue.types";
import LArtwork from "@components/LArtwork";
import React from "react";
import PlayPauseButton from "./PlayPauseButton";
import { Image } from "expo-image";
import { getImageUrlWithSize } from "@utils/index";
import { captureException } from "@utils/captureException";

interface FeedExperienceProps extends LBoxProps {
  data: QueueItem;
  disabled?: boolean;
  height: number;
  width: number;
}

// PERF: Track prefetched URLs to avoid redundant prefetching
const prefetchedUrls = new Set<string>();

const FeedExperience = ({
  data,
  disabled,
  height,
  width,
  ...lboxProps
}: FeedExperienceProps) => {
  const albumImage = data.metadata.albums.at(0)?.image;

  useEffect(() => {
    // To be used by BarMusicPlayer
    const url = getImageUrlWithSize(albumImage, "small");
    if (!url || prefetchedUrls.has(url)) return;
    prefetchedUrls.add(url);
    Image.prefetch(url, "disk").catch((error) => {
      captureException(error, {
        channel: "ignore",
        area: "image",
        operation: "prefetch-feed-access-image",
      });
    });
  }, [albumImage]);

  return (
    <LBox
      height={height}
      width={width}
      overflow="hidden"
      alignItems="center"
      justifyContent="center"
      {...lboxProps}
    >
      <PlayPauseButton disabled={disabled}>
        <LBox>
          <LArtwork
            alignSelf="center"
            imageSize="xLarge"
            overflow="hidden"
            size={height}
            transition="disabled"
            url={albumImage}
          />
        </LBox>
      </PlayPauseButton>
    </LBox>
  );
};

export default FeedExperience;
